import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheIgnition() {
  return <section data-section-id="233673" id="ready-to-scale" className="bg-background text-foreground relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary/80 to-background" />

      {}
      <div className="absolute inset-0 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666336/img/money_rain_texture.png)] bg-repeat opacity-[0.08] mix-blend-screen" />

      {}
      <div className="relative z-10 flex w-full max-w-7xl flex-col items-center justify-center gap-12 px-4 py-24 text-center sm:gap-16 sm:px-8">
        <h2 className="font-default text-primary-foreground mx-auto max-w-[12ch] break-words text-[4.5rem] font-bold leading-[0.85] tracking-tighter uppercase sm:text-8xl md:text-9xl lg:text-[10rem] drop-shadow-2xl">
          Ready to Secure the Funding You Deserve?
        </h2>

        <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 font-default shadow-3xl rounded-md px-10 py-8 text-base font-semibold tracking-[0.2em] uppercase transition-transform duration-300 hover:scale-105 sm:px-14 sm:py-10 sm:text-xl border-b-4 border-primary/20">
          <Link to="/CreditSolutionsPage">Start Your Journey</Link>
        </Button>
      </div>
    </section>;
}